import { 
	VideoSection
} from './HeroSectionVideo.styled';

interface Props {
	videoUrl: string;
	showBorder: boolean;
	isVimeo: boolean;
}

export const SectionVideo = ({ 
	videoUrl, 
	showBorder,
	isVimeo,
}: Props) => {

	const getVimeoId = (url: string) => {
		const id = url.split('/').pop();
		return id;
	};

	return (
		<VideoSection $showBorder={showBorder} style={{ cursor: isVimeo ? 'pointer' : 'default' }}>
			{isVimeo ? (
				<iframe
					src={`https://player.vimeo.com/video/${getVimeoId(videoUrl)}?
					autoplay=0&controls=1&title=0&byline=0&portrait=0`}
					style={{ width: '100%', height: '100%', border: 'none' }}
					allow="fullscreen; picture-in-picture"
					allowFullScreen
				/>
			) : (
				<video
					src={videoUrl}
					autoPlay
					loop
					muted
					style={{ width: '100%', height: '100%' }}
				/>
			)}
		</VideoSection>
	);
};
